module.exports = __webpack_public_path__ + "static/media/general-de-seguros-street-selected.21695a20.svg";